import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {createSubmittal} from "../../../actions/submittals";
import {SubmittalForm} from "./SubmittalForm";
import {currentEffectiveUserId} from "../../../reducers/ui";

const SubmittalNew = props => {
  const { projectid, onSubmit, onCancel, userid } = props;
  return <Card title='Submittal Details' className={'edit-view'}>
    <SubmittalForm projectid={projectid} onCancel={onCancel} onSubmit={onSubmit} userid={userid}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => ({ projectid: props.match.params.id, userid: currentEffectiveUserId(state) }),
    (dispatch, props) => ({
      onSubmit: (submittal) => {
        return dispatch(createSubmittal(props.match.params.id, submittal, (submittalid) => props.history.push(`/projects/${props.match.params.id}/submittals/${submittalid}`)));
      },
      onCancel: () => props.history.goBack()
    })
  )
)(SubmittalNew);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/SubmittalNew.js